export const Superadmin = () => import("./SuperAdmin");
export const SuperadminDashboard = () => import("./pages/SuperadminDashboard");
export const SuperadminProfile = () => import("./pages/SuperadminProfile");
